import { render } from "./AttachProjectSlideOverComponent.vue?vue&type=template&id=4c23e54d"
import script from "./AttachProjectSlideOverComponent.vue?vue&type=script&lang=js"
export * from "./AttachProjectSlideOverComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__